import { AgGridReact } from 'ag-grid-react';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { RefObject } from 'react';
import { ComposedTableDataType } from 'components/ComposedTable/types';
import { printParams } from './constants';
import getDocDefinition from './docDefinition';
import { ExportParamsType, VendorsInvoicePairsType } from './types';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const pdfMake = require('pdfmake/build/pdfmake.js');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const printGridData = async <TData extends ComposedTableDataType>(
  gridRef: RefObject<AgGridReact<TData>>,
  exportParams: ExportParamsType,
  selectedVendorInvoicePairs: VendorsInvoicePairsType[],
  toDownload?: boolean,
  interCompanyFlag?: boolean
): Promise<string | undefined> =>
  new Promise((resolve, reject) => {
    try {
      const {
        selectedTab,
        intl,
        totalsInFooter,
        tableHeaderFilters,
        activeAuthorizePaymentPage
      } = exportParams;
      const docDefinition = getDocDefinition(
        printParams,
        gridRef,
        {
          selectedTab,
          intl,
          totalsInFooter,
          tableHeaderFilters,
          activeAuthorizePaymentPage
        },
        selectedVendorInvoicePairs,
        interCompanyFlag
      );
      const pdfGen = pdfMake.createPdf(docDefinition);
      if (!toDownload) {
        pdfGen.getBase64(resolve);
      } else {
        pdfGen.download('export', () => resolve(undefined));
      }
    } catch (e) {
      console.log(`error in generating pdf: ${e}`);
      reject(e);
    }
  });

export default printGridData;
